import { gettingStarted } from './privateCloudBusinessEditionFieldConfigVMware';
export const pagesConfig = [...gettingStarted()];
